import React from "react";

interface CheckCircleIconProps extends React.SVGProps<SVGSVGElement> {
  width?: string;
  height?: string;
  fill?: string;
  ariaLabel?: string; 
}

const CheckCircleIcon: React.FC<CheckCircleIconProps> = ({
  width = "11",
  height = "11",
  fill = "#BDBDBD",
  ariaLabel = "Check circle icon", 
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img" 
    aria-label={ariaLabel} 
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.50065 0.0830078C2.51065 0.0830078 0.0839844 2.50967 0.0839844 5.49967C0.0839844 8.48967 2.51065 10.9163 5.50065 10.9163C8.49065 10.9163 10.9173 8.48967 10.9173 5.49967C10.9173 2.50967 8.49065 0.0830078 5.50065 0.0830078ZM4.41732 8.20801L1.70898 5.49967L2.47273 4.73592L4.41732 6.67509L8.52857 2.56384L9.29232 3.33301L4.41732 8.20801Z"
      fill={fill}
    />
  </svg>
);

export default CheckCircleIcon;
